import { render, staticRenderFns } from "./windowParamsPropData.vue?vue&type=template&id=198debe4&scoped=true&"
import script from "./windowParamsPropData.vue?vue&type=script&lang=js&"
export * from "./windowParamsPropData.vue?vue&type=script&lang=js&"
import style0 from "./windowParamsPropData.vue?vue&type=style&index=0&id=198debe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198debe4",
  null
  
)

export default component.exports